import React from 'react';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grade from '@material-ui/icons/Grade';

const useStyles = makeStyles((theme) => ({
  rate: {
    padding: `0 ${theme.typography.pxToRem(11)}`,
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[100]}`,
    borderRadius: theme.typography.pxToRem(10.5),
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(16),
    height: theme.typography.pxToRem(21),
  },
  rateValaue: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.grey[600],
    // lineHeight: "initial",
  },
  ratelabel: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.grey[600],
    whiteSpace: 'pre',
  },
  rateStar: {
    width: theme.typography.pxToRem(16),
    height: theme.typography.pxToRem(16),
    color: theme.palette.warning.main,
    marginLeft: theme.typography.pxToRem(3),
  },
  whiteSpace: {
    width: theme.typography.pxToRem(3),
    display: 'inline-block',
  },
}));

export default function RateWidget(props) {
  const { type, value, text } = props;
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      className={classes.rate}
    >
      <Typography component="span" className={classes.rateValaue}>
        {value}
      </Typography>
      {type == 'rate' ? (
        <Grade className={classes.rateStar} />
      ) : (
        <Typography component="span" className={classes.ratelabel}>
          {` ${text}`}
        </Typography>
      )}
    </Box>
  );
}
